import { Sentry } from "./sentry";

window.addEventListener("cranky:cart:update", () => {
  const cart = window.Alpine.store("cart");
  const tiers = window.TIERED_PRICING_ARRAY;

  const currentTier = tiers.filter((tier) => tier.activation_threshold <= cart.original_total_price).at(-1);
  const expectedReward = /^\d+/.exec(currentTier?.reward || "")?.[0];
  const computedReward = ((cart.total_discount / cart.original_total_price) * 100).toFixed();

  if (expectedReward && computedReward !== expectedReward) {
    // @ts-ignore
    delete cart.token, delete cart.items_added, delete cart.items_removed;

    // Sentry.captureEvent({
    //   level: "fatal",
    //   message: `Tiered Pricing Reward Mismatch [${expectedReward}%]`,
    //   extra: {
    //     computedReward,
    //     expectedReward,
    //     cart: JSON.stringify(cart, null, 2),
    //   },
    // });
  }
});

declare global {
  interface Window {
    dataLayer: Record<string, any>[];
    gtag: (event: string, action: string, params: Record<string, any>) => void;
  }
}

window.dataLayer = window.dataLayer || [];
window.gtag ??= function () {
  window.dataLayer.push(arguments);
};
